import netsAnsweringRuleList from './nets-answering-rule-list';
import moduleConfig from './module-config';

export default angular
  .module('app.answeringRuleList', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsAnsweringRuleList', netsAnsweringRuleList);
